<template>
  <div>
    <div class="card shadow border-0">

      <div class="card-header bg-white border-0 py-3">

        <div class="d-flex justify-content-between align-items-center">

          <div>

            <h3 class="mb-0 text-primary font-weight-bold">
              <i class="fas fa-project-diagram mr-2"></i>
              REPORTE TRAZABILIDAD
            </h3>

            <small class="text-muted">
              Consulta de trazabilidad de materias primas
            </small>

          </div>

          <div>

            <button class="btn btn-primary btn-lg mr-2 shadow-sm" @click="cargar_datos">

              <i class="fas fa-search mr-1"></i>

              Filtrar

            </button>

            <button class="btn btn-success btn-lg shadow-sm" @click="exportar_excel">

              <i class="fas fa-file-excel mr-1"></i>

              Exportar Excel

            </button>

          </div>

        </div>

      </div>



      <div class="card-body">



        <div class="card border-0 shadow-sm">

          <div class="card-header bg-white">

            <h5 class="mb-0">

              <i class="fas fa-filter text-primary"></i>

              Filtros

            </h5>

          </div>



          <div class="card-body">



            <div class="row">



              <div class="col-xl-4 col-lg-6 mb-3">

                <label class="font-weight-bold">

                  Rango de Fechas

                </label>

                <date-picker v-model="fechas" :range="true" format="DD-MM-YYYY" value-type="YYYY-MM-DD"
                  :editable="false" :clearable="true" style="width:100%;"></date-picker>

              </div>



              <div class="col-xl-2 col-lg-3 mb-3">

                <label class="font-weight-bold">

                  Ticket

                </label>

                <input type="number" class="form-control" v-model="codigo_ticket">

              </div>



              <div class="col-xl-2 col-lg-3 mb-3">

                <label class="font-weight-bold">

                  Guía

                </label>

                <input type="number" class="form-control" v-model="numero_guia">

              </div>



              <div class="col-xl-4 col-lg-12 mb-3">

                <label class="font-weight-bold">

                  Proveedor

                </label>

                <v-select :reduce="option => option.id" v-model="empresas_id" :options="proveedores" label="nombre"
                  multiple :closeOnSelect="false">

                </v-select>

              </div>



              <div class="col-xl-4 mb-3">

                <label class="font-weight-bold">

                  Materia Prima

                </label>

                <v-select :reduce="option => option.id" v-model="mps_id" :options="materias_primas" label="nombre"
                  multiple @input="obtener_parametros_mp()">

                </v-select>

              </div>



              <div class="col-xl-4 mb-3">

                <label class="font-weight-bold">

                  Especie

                </label>

                <v-select :reduce="option => option.id" v-model="especies_id" :options="especies" label="nombre"
                  multiple>

                </v-select>

              </div>

              <div class="col-xl-4 mb-3">

                <label class="font-weight-bold">

                  Destino

                </label>

                <v-select class="" :reduce="option => option.id" v-model="destinos_id" :options="destinos"
                  label="nombre" multiple>
                  <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching">
                      No se Encontraron Resultados Para <em>{{ search }}</em>.
                    </template>
                    <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                  </template>
                </v-select>

              </div>



            </div>



          </div>

        </div>



        <div class="mt-4">

          <div class="card shadow-sm border-0 mt-4">

            <ul class="nav nav-tabs mb-3">
              <li class="nav-item">
                <a class="nav-link" :class="{ active: tabActiva == 'harina' }" href="#"
                  @click.prevent="tabActiva = 'harina'">
                  <i class="fas fa-industry mr-1"></i>
                  Harina y Aceite
                  <span class="badge badge-primary ml-1">{{ datos1.length }}</span>
                </a>
              </li>

              <li class="nav-item">
                <a class="nav-link" :class="{ active: tabActiva == 'hidrolizado' }" href="#"
                  @click.prevent="tabActiva = 'hidrolizado'">
                  <i class="fas fa-flask mr-1"></i>
                  Hidrolizado
                  <span class="badge badge-success ml-1">{{ datos2.length }}</span>
                </a>
              </li>

              <li class="nav-item">
                <a class="nav-link" :class="{ active: tabActiva == 'vertedero' }" href="#"
                  @click.prevent="tabActiva = 'vertedero'">
                  <i class="fas fa-flask mr-1"></i>
                  Vertedero
                  <span class="badge badge-danger ml-1">{{ datos3.length }}</span>
                </a>
              </li>
            </ul>

            <div v-if="tabActiva == 'harina'">

              <div class="card-header bg-white">

                <div class="d-flex justify-content-between align-items-center">

                  <div>

                    <h5 class="mb-0">

                      <i class="fas fa-table text-primary mr-2"></i>

                      Resultado de la Consulta

                    </h5>

                    <small class="text-muted">

                      {{ datos1.length }} registros encontrados

                    </small>

                  </div>

                  <div>

                    <span class="badge badge-primary p-2">

                      {{ datos1.length }}

                    </span>

                  </div>

                </div>

              </div>



              <div class="card-body p-0">

                <div class="table-responsive tableFixHead">

                  <table class="table table-hover table-striped table-bordered mb-0">

                    <thead>

                      <tr>

                        <th v-for="c in columnas1" :key="c.label" v-show="c.show"
                          class="text-center align-middle encabezado-tabla">

                          {{ c.label }}

                        </th>

                      </tr>

                    </thead>



                    <tbody>

                      <tr v-for="d in datos1" :key="d.id" :class="{

                        'fila-error': d.marcar_rojo == 1,

                        'fila-seleccionada': d.seleccionado == 1

                      }">

                        <td v-for="c in columnas1" :key="c.label" v-show="c.show" @click="

                          d.seleccionado =

                          d.seleccionado ? 0 : 1

                          " class="align-middle">

                          <span>

                            {{ devuelve_valor(d, c.path, c.tipo) }}

                          </span>

                        </td>

                      </tr>



                      <tr v-if="datos1.length == 0">

                        <td :colspan="columnas1.filter(c => c.show).length" class="text-center py-5 text-muted">

                          <i class="fas fa-search fa-3x mb-3"></i>

                          <br>

                          No existen registros para mostrar

                        </td>

                      </tr>

                    </tbody>

                  </table>

                </div>

              </div>

            </div>

            <div v-if="tabActiva == 'hidrolizado'">

              <div class="card-header bg-white">

                <div class="d-flex justify-content-between align-items-center">

                  <div>

                    <h5 class="mb-0">

                      <i class="fas fa-table text-primary mr-2"></i>

                      Resultado de la Consulta

                    </h5>

                    <small class="text-muted">

                      {{ datos2.length }} registros encontrados

                    </small>

                  </div>

                  <div>

                    <span class="badge badge-primary p-2">

                      {{ datos2.length }}

                    </span>

                  </div>

                </div>

              </div>



              <div class="card-body p-0">

                <div class="table-responsive tableFixHead">

                  <table class="table table-hover table-striped table-bordered mb-0">

                    <thead>

                      <tr>

                        <th v-for="c in columnas2" :key="c.label" v-show="c.show"
                          class="text-center align-middle encabezado-tabla">

                          {{ c.label }}

                        </th>

                      </tr>

                    </thead>



                    <tbody>

                      <tr v-for="d in datos2" :key="d.id" :class="{

                        'fila-error': d.marcar_rojo == 1,

                        'fila-seleccionada': d.seleccionado == 1

                      }">

                        <td v-for="c in columnas2" :key="c.label" v-show="c.show" @click="

                          d.seleccionado =

                          d.seleccionado ? 0 : 1

                          " class="align-middle">

                          <span>

                            {{ devuelve_valor(d, c.path, c.tipo) }}

                          </span>

                        </td>

                      </tr>



                      <tr v-if="datos2.length == 0">

                        <td :colspan="columnas2.filter(c => c.show).length" class="text-center py-5 text-muted">

                          <i class="fas fa-search fa-3x mb-3"></i>

                          <br>

                          No existen registros para mostrar

                        </td>

                      </tr>

                    </tbody>

                  </table>

                </div>

              </div>

            </div>

            <div v-if="tabActiva == 'vertedero'">

              <div class="card-header bg-white">

                <div class="d-flex justify-content-between align-items-center">

                  <div>

                    <h5 class="mb-0">

                      <i class="fas fa-table text-primary mr-2"></i>

                      Resultado de la Consulta

                    </h5>

                    <small class="text-muted">

                      {{ datos3.length }} registros encontrados

                    </small>

                  </div>

                  <div>

                    <span class="badge badge-primary p-2">

                      {{ datos3.length }}

                    </span>

                  </div>

                </div>

              </div>



              <div class="card-body p-0">

                <div class="table-responsive tableFixHead">

                  <table class="table table-hover table-striped table-bordered mb-0">

                    <thead>

                      <tr>

                        <th v-for="c in columnas3" :key="c.label" v-show="c.show"
                          class="text-center align-middle encabezado-tabla">

                          {{ c.label }}

                        </th>

                      </tr>

                    </thead>



                    <tbody>

                      <tr v-for="d in datos3" :key="d.id" :class="{

                        'fila-error': d.marcar_rojo == 1,

                        'fila-seleccionada': d.seleccionado == 1

                      }">

                        <td v-for="c in columnas3" :key="c.label" v-show="c.show" @click="

                          d.seleccionado =

                          d.seleccionado ? 0 : 1

                          " class="align-middle">

                          <span>

                            {{ devuelve_valor(d, c.path, c.tipo) }}

                          </span>

                        </td>

                      </tr>



                      <tr v-if="datos3.length == 0">

                        <td :colspan="columnas3.filter(c => c.show).length" class="text-center py-5 text-muted">

                          <i class="fas fa-search fa-3x mb-3"></i>

                          <br>

                          No existen registros para mostrar

                        </td>

                      </tr>

                    </tbody>

                  </table>

                </div>

              </div>

            </div>

          </div>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    fechas: [],
    todos: true,
    tabActiva: 'harina',
    columnas1: [
      {
        show: true,
        label: "FECHA Y HORA DE RECEPCION",
        tipo: "datetime",
        path: "fecha_hora_recepcion",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "FECHA Y HORA SALIDA DE ORIGEN",
        tipo: "datetime",
        path: "fecha_hora_origen",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "N° TICKET",
        tipo: "string",
        path: "numero_ticket",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "PATENTE",
        tipo: "string",
        path: "patente",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "BINS",
        tipo: "string",
        path: "bins",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "N° GUÍA",
        tipo: "string",
        path: "numero_guia",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "FECHA GUÍA",
        tipo: "date",
        path: "fecha_guia",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "NOMBRE PROVEEDOR",
        tipo: "string",
        path: "nombre_proveedor",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "CODIGO AGENTE ORIGEN",
        tipo: "string",
        path: "codigo_agente_origen",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "NOMBRE AGENTE ORIGEN",
        tipo: "string",
        path: "nombre_agente_origen",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "PESO NETO INF.(TON.) S/DESC.",
        tipo: "decimal_cl",
        path: "neto_informado_toneladas",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "PESO NETO INFORMADO (TON.) C/DESC.",
        tipo: "decimal_cl",
        path: "guia_ton",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "PESO ROMANA (TON)",
        tipo: "decimal_cl",
        path: "peso_corregido_guia_toneladas",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "PESO ROMANA (Ton.) MENOS VERTEDERO",
        tipo: "decimal_cl",
        path: "peso_distribucion_toneladas",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "PRODUCTO DESTINO",
        tipo: "string",
        path: "producto_destino",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "LÍNEA",
        tipo: "string",
        path: "linea",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "CR/SR",
        tipo: "string",
        path: "con_sin_restriccion",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "RESTRICCIÓN",
        tipo: "string",
        path: "restricciones",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "TIPO MMPP ESPECIE",
        tipo: "string",
        path: "tipo_mmpp_especies",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "TIEMPO TRASLADO (HRS)",
        tipo: "string",
        path: "tiempo_traslado",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "MENOS DE 24 HORAS DE TRASLADO O REFRIGERADO",
        tipo: "string",
        path: "cumple_24_hrs",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "FOLIO PCC",
        tipo: "string",
        path: "folio_pcc",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "PCC CUMPLE/NO CUMPLE",
        tipo: "string",
        path: "folio_pcc",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "CODIGO CENTRO ORIGEN",
        tipo: "string",
        path: "codigo_centro_origen",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "NOMBRE CENTRO ORIGEN",
        tipo: "string",
        path: "nombre_centro_origen",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "JAULA DE ORIGEN",
        tipo: "string",
        path: "centro_origen_jaula",
        ancho_excel: 22,
      },
    ],
    columnas2: [
      {
        show: true,
        label: "FECHA Y HORA DE RECEPCION",
        tipo: "datetime",
        path: "fecha_hora_recepcion",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "N° TICKET",
        tipo: "string",
        path: "numero_ticket",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "PATENTE",
        tipo: "string",
        path: "patente",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "BINS",
        tipo: "string",
        path: "bins",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "BARCO",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "FECHA GUÍA",
        tipo: "date",
        path: "fecha_guia",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "N° GUÍA LP",
        tipo: "string",
        path: "numero_guia",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "N° GUÍA ORIGEN",
        tipo: "string",
        path: "numero_guia_origen",
        ancho_excel: 22,
      },

      {
        show: true,
        label: "NOMBRE PROVEEDOR",
        tipo: "string",
        path: "nombre_proveedor",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "CODIGO AGENTE ORIGEN",
        tipo: "string",
        path: "codigo_agente_origen",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "NOMBRE AGENTE ORIGEN",
        tipo: "string",
        path: "nombre_agente_origen",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "PESO NETO INF.(TON.) S/DESC.",
        tipo: "decimal_cl",
        path: "neto_informado_toneladas",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "PESO NETO INFORMADO (TON.) C/DESC.",
        tipo: "decimal_cl",
        path: "guia_ton",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "PESO ROMANA (TON)",
        tipo: "decimal_cl",
        path: "peso_corregido_guia_toneladas",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "PESO ROMANA (Ton.) MENOS VERTEDERO",
        tipo: "decimal_cl",
        path: "peso_distribucion_toneladas",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "PRODUCTO DESTINO",
        tipo: "string",
        path: "producto_destino",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "TIPO MMPP ESPECIE",
        tipo: "string",
        path: "tipo_mmpp_especies",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "FOLIO PCC",
        tipo: "string",
        path: "folio_pcc",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "PCC CUMPLE/NO CUMPLE",
        tipo: "string",
        path: "folio_pcc",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "CODIGO CENTRO ORIGEN",
        tipo: "string",
        path: "codigo_centro_origen",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "NOMBRE CENTRO ORIGEN",
        tipo: "string",
        path: "nombre_centro_origen",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "JAULA DE ORIGEN",
        tipo: "string",
        path: "centro_origen_jaula",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "MUELLE",
        tipo: "string",
        path: "muelle",
        ancho_excel: 22,
      },
    ],
    columnas3: [
      {
        show: true,
        label: "FECHA Y HORA DE RECEPCION",
        tipo: "datetime",
        path: "fecha_hora_recepcion",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "FECHA Y HORA SALIDA DE ORIGEN",
        tipo: "datetime",
        path: "fecha_hora_origen",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "N° TICKET",
        tipo: "string",
        path: "numero_ticket",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "PATENTE",
        tipo: "string",
        path: "patente",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "BINS",
        tipo: "string",
        path: "bins",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "N° GUÍA",
        tipo: "string",
        path: "numero_guia",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "FECHA GUÍA",
        tipo: "date",
        path: "fecha_guia",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "NOMBRE PROVEEDOR",
        tipo: "string",
        path: "nombre_proveedor",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "CODIGO AGENTE ORIGEN",
        tipo: "string",
        path: "codigo_agente_origen",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "NOMBRE AGENTE ORIGEN",
        tipo: "string",
        path: "nombre_agente_origen",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "PESO NETO INF.(TON.) S/DESC.",
        tipo: "decimal_cl",
        path: "neto_informado_toneladas",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "PESO NETO INFORMADO (TON.) C/DESC.",
        tipo: "decimal_cl",
        path: "guia_ton",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "PESO ROMANA (TON)",
        tipo: "decimal_cl",
        path: "peso_corregido_guia_toneladas",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "PESO A VERTEDERO (Ton.)",
        tipo: "decimal_cl",
        path: "peso_distribucion_toneladas",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "PRODUCTO DESTINO",
        tipo: "string",
        path: "producto_destino",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "LÍNEA",
        tipo: "string",
        path: "linea",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "CR/SR",
        tipo: "string",
        path: "con_sin_restriccion",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "RESTRICCIÓN",
        tipo: "string",
        path: "restricciones",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "TIPO MMPP ESPECIE",
        tipo: "string",
        path: "tipo_mmpp_especies",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "TIEMPO TRASLADO (HRS)",
        tipo: "string",
        path: "tiempo_traslado",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "MENOS DE 24 HORAS DE TRASLADO O REFRIGERADO",
        tipo: "string",
        path: "cumple_24_hrs",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "FOLIO PCC",
        tipo: "string",
        path: "folio_pcc",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "PCC CUMPLE/NO CUMPLE",
        tipo: "string",
        path: "folio_pcc",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "CODIGO CENTRO ORIGEN",
        tipo: "string",
        path: "codigo_centro_origen",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "NOMBRE CENTRO ORIGEN",
        tipo: "string",
        path: "nombre_centro_origen",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "JAULA DE ORIGEN",
        tipo: "string",
        path: "centro_origen_jaula",
        ancho_excel: 22,
      },
    ],

    proveedores: [],
    datos1: [],
    datos2: [],
    datos3: [],
    mps_id: [],
    destinos_id: [],
    empresas_id: [],
    especies_id: [],
    materias_primas: [],
    especies: [],
    mps_seleccionadas: [],
    destinos: [],
    total_resultado: null,
    url_excel: null,
    agrupar_empresa: true,
    agrupar_sucursal: true,
    codigo_ticket: "",
    numero_guia: "",
  }),
  mounted() {
    this.cargar_materias_primas();
  },
  methods: {
    async cargar_materias_primas() {
      await this.axios
        .get(`${this.api}/mps_tipo?limit=999999999`, this.cabeceras_json)
        .then((res) => {
          this.materias_primas = res.data.data.data;
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_destinos();
    },

    async cargar_destinos() {
      await this.axios
        .get(`${this.api}/destinos`, this.cabeceras_json)
        .then((res) => {
          this.destinos = res.data.data;
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_proveedores();
    },

    async cargar_proveedores() {
      /* await this.axios.get(`${this.api}/empresas?tipo_empresa_ids=4&agrupada_en_null=not_null&limit=9999999999`,this.cabeceras_json).then((res)=>{
            this.proveedores = res.data.data.data
            ////console.log('res',res.data.data.data);
          }).catch((e)=>{
            //console.log(e);
          }); */
      await this.axios
        .get(`${this.api}/proveedores/trazabilidad`, this.cabeceras_json)
        .then((res) => {
          this.proveedores = res.data.data;
          console.log("res", res.data.data);
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_especies();
    },

    async cargar_especies() {
      await this.axios
        .get(`${this.api}/especies?limit=9999999999`, this.cabeceras_json)
        .then((res) => {
          this.especies = res.data.data.data;
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    async filtrarProveedores(search) {
      await this.axios
        .get(
          `${this.api}/empresas?nombre=${search}&tipo_empresa_ids=4&agrupada_en_null=not_null&limit=9999999999`,
          this.cabeceras_json
        )
        .then((res) => {
          this.proveedores = res.data.data.data;
          ////console.log('res',res.data.data.data);
        })
        .catch((e) => {
          //console.log(e);
        });
      ////console.log('search',search)
      ////console.log('col',col)
    },

    async cargar_datos() {
      let loader = this.$loading.show({
        // Optional parameters
        //container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        color: "#262b63",
        backgroundColor: "#ededed",
        //onCancel: this.onCancel,
        loader: "spinner",
      });
      //if(this.fechas[0] != null && this.fechas[0] != undefined){
      let body = {
        //mps_id: this.mps_id,
        //empresas_id:this.empresas_id,
        //destinos_id: this.destinos_id,
        //especies_id: this.especies_id,
        agrupar_empresa: this.agrupar_empresa,
        agrupar_sucursal: this.agrupar_sucursal,

      };

      if (this.mps_id.length > 0) {
        body.mps_id = this.mps_id;
      }

      if (this.destinos_id.length > 0) {
        body.destinos_id = this.destinos_id;
      }

      if (this.especies_id.length > 0) {
        body.especies_id = this.especies_id;
      }

      if (this.empresas_id.length > 0) {
        body.empresas_id = this.empresas_id;
      }

      if (this.fechas[0] != null && this.fechas[0] != undefined) {
        body.desde = this.fechas[0];
        body.hasta = this.fechas[1];
      }

      if (this.codigo_ticket) {
        body.codigo_ticket = this.codigo_ticket;
      }
      if (this.numero_guia) {
        body.numero_guia = this.numero_guia;
      }

      await this.axios
        .post(`${this.api}/reportes/trazabilidad`, body, this.cabeceras_json)
        .then((res) => {
          console.log(res.data.data);
          this.datos1 = res.data.data1;
          this.datos2 = res.data.data2;
          this.datos3 = res.data.data3;
          //this.total_resultado = res.data.data.total;
          this.url_excel = res.data.url;
          loader.hide();
        })
        .catch((e) => {
          //console.log(e);
          loader.hide();
        });
      //}
    },

    async exportar_excel() {
      window.open(this.url_excel, "_blank");
      /* let body = {
                desde:this.fechas[0],
                hasta:this.fechas[1],
                mps_id:this.mps_id,
                empresas_id:this.empresas_id,
                destinos_id:this.destinos_id,
                especies_id:this.especies_id,
                agrupar_empresa:this.agrupar_empresa,
                agrupar_sucursal:this.agrupar_sucursal,
                columnas:this.columnas.filter(c => c.show == true && c.path != 'declaracion_jurada' && c.path != 'cam').map((c)=>{
                    return {cabecera:c.label,path:c.path}
                })
            };
            await this.axios.post(`${this.api}/reportes/personalizado_excel`,body,this.cabeceras_json).then((res)=>{
                this.url_excel = res.data.data.url;
                window.open(this.url_excel, '_blank');
                //console.log(this.url_excel,res.data);
            }).catch((e)=>{
                //console.log(e);
            }); */
    },

    devuelve_valor(item, path, tipo_dato) {
      let keys = path.split(".");
      let valor = item;
      keys.forEach((k) => {
        for (var key in valor) {
          if (key == k) {
            valor = valor[key];
          }
        }
      });
      if (tipo_dato == "datetime") {
        valor = this.$options.filters.fecha_hora(valor);
      }
      if (tipo_dato == "date") {
        valor = this.$options.filters.fecha(valor);
      }
      if (tipo_dato == "time") {
        valor = this.$options.filters.hora(valor);
      }
      if (tipo_dato == "decimal_cl") {
        valor = (Math.trunc(Number(valor) * 1000) / 1000)
          .toString()
          .replace('.', ',');
      }
      return valor;
    },

    setearTodos() {
      this.columnas1.forEach((c) => {
        c.show = this.todos;
      });
    },

    abrirPdf(d) {
      window.open(`${this.api_public}/guias/${d.url_guia}`, "_blank");
    },

    abrirDeclaracion(d) {
      window.open(
        `${this.api_public}/guias/archivos_adicionales/${d.declaracion_jurada}`,
        "_blank"
      );
    },

    abrirCam(d) {
      window.open(
        `${this.api_public}/guias/archivos_adicionales/${d.cam}`,
        "_blank"
      );
    },
  },
  computed: {
    ...mapState(["api", "api_public", "cabeceras_json", "token"]),
  },
};
</script>
<style scoped>
/* ============================
   TARJETAS
============================ */

.card {
  border-radius: 12px;
  border: none;
}

.card-header {
  border-bottom: 1px solid #edf2f7;
  background: #ffffff;
}

.card-header h3,
.card-header h5 {
  font-weight: 600;
}


/* ============================
   BOTONES
============================ */

.btn {

  border-radius: 8px;

  transition: .20s;

  font-weight: 600;

}

.btn-primary {

  background: #1565C0;

  border-color: #1565C0;

}

.btn-primary:hover {

  background: #0D47A1;

}

.btn-success {

  background: #2E7D32;

  border-color: #2E7D32;

}

.btn-success:hover {

  background: #1B5E20;

}

.btn-lg {

  min-width: 140px;

}


/* ============================
   LABELS
============================ */

label {

  font-size: .82rem;

  color: #607D8B;

  margin-bottom: 6px;

  font-weight: 600;

}


/* ============================
   INPUTS
============================ */

.form-control {

  border-radius: 8px;

  border: 1px solid #CFD8DC;

  transition: .2s;

}

.form-control:focus {

  border-color: #1565C0;

  box-shadow: 0 0 0 .15rem rgba(21, 101, 192, .15);

}


/* ============================
   V-SELECT
============================ */

.vs__dropdown-toggle {

  min-height: 40px;

  border-radius: 8px !important;

  border: 1px solid #CFD8DC !important;

}

.vs__selected {

  background: #E3F2FD !important;

  border-radius: 4px;

}


/* ============================
   TABLA
============================ */

.table {

  margin-bottom: 0;

  font-size: 13px;

}

.table thead th {

  position: sticky;

  top: 0;

  z-index: 100;

}


/* Encabezado */

.encabezado-tabla {

  background: linear-gradient(180deg,
      #1976D2,
      #1565C0);

  color: white;

  font-weight: 600;

  font-size: 13px;

  border-color: #0D47A1 !important;

  white-space: nowrap;

}


/* Celdas */

.table td {

  vertical-align: middle;

  padding: .45rem;

}


/* Zebra */

.table-striped tbody tr:nth-of-type(odd) {

  background: #FAFCFE;

}


/* Hover */

.table-hover tbody tr:hover {

  background: #E3F2FD;

  cursor: pointer;

}


/* ============================
   FILA SELECCIONADA
============================ */

.fila-seleccionada {

  background: #CFE8FF !important;

}


/* ============================
   FILA ERROR
============================ */

.fila-error {

  background: #FFE5E5 !important;

}


/* ============================
   BADGE
============================ */

.badge {

  font-size: .9rem;

  border-radius: 20px;

}


/* ============================
   SCROLL
============================ */

.tableFixHead {

  overflow: auto;

  max-height: 70vh;

}


/* Scroll Chrome */

.tableFixHead::-webkit-scrollbar {

  width: 10px;

  height: 10px;

}

.tableFixHead::-webkit-scrollbar-track {

  background: #ECEFF1;

}

.tableFixHead::-webkit-scrollbar-thumb {

  background: #90A4AE;

  border-radius: 20px;

}

.tableFixHead::-webkit-scrollbar-thumb:hover {

  background: #607D8B;

}


/* ============================
   DATE PICKER
============================ */

.mx-datepicker {

  width: 100%;

}

.mx-input {

  height: 40px;

  border-radius: 8px;

  border: 1px solid #CFD8DC;

}


/* ============================
   SOMBRAS
============================ */

.shadow-sm {

  box-shadow: 0 2px 10px rgba(0, 0, 0, .05) !important;

}

.shadow {

  box-shadow: 0 6px 20px rgba(0, 0, 0, .08) !important;

}


/* ============================
   ANIMACIONES
============================ */

.card {

  animation: fadeIn .25s;

}

@keyframes fadeIn {

  from {

    opacity: 0;

    transform: translateY(8px);

  }

  to {

    opacity: 1;

    transform: none;

  }

}
</style>
<style>
body {}
</style>